import {Component, Input, OnInit} from '@angular/core';
import {Base}                     from '../shared/api/bases/api.models';
import {Schema}                   from '../shared/api/bases/proxy/schemas/schema.interface';
import {NgbActiveModal}           from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'schema-copy',
    template: require('./schema-copy.modal.html'),
    styles: [require('./schema-copy.modal.scss')]
})
export class SchemaCopyModal implements OnInit {
    @Input() toBase: Base;
    @Input() currentBase: Base;
    @Input() bases: Base[];
    @Input() schema: Schema;

    constructor(public activeModal: NgbActiveModal) {}

    public ngOnInit(): void {
        this.toBase = this.currentBase;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/schemas/schema-copy.modal.ts